import { render, staticRenderFns } from "./sortable-list-item.vue?vue&type=template&id=d7b15382&"
import script from "./sortable-list-item.vue?vue&type=script&lang=js&"
export * from "./sortable-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports